<template>
  <div class="shareTable">
    <Table :columns="columns" border :data="tableList" :loading="loading">
      <template slot="shareCount" slot-scope="{row,index}">
        <span v-if="row.shareCount == null">1</span>
        <span v-else>{{row.shareCount}}</span>
      </template>
      <template slot="createBy" slot-scope="{row,index}">
          <template v-if="row.modifyBy!= null && row.modifyBy !=''">
            <span v-if="row.modifyBy == 'AdminRule'">官方平台</span>
            <span v-else>{{row.createBy}}</span>
          </template>
          <template v-else>{{row.createBy}}</template>
      </template>
      <template slot="action" slot-scope="{row,index}">
        <Button size="small" style="line-height:24px; font-size:12px;" v-if="row.isCopy" disabled>已采用</Button>
        <Button size="small" v-else type="info" :disabled="row.createBy == $store.state.user.userInfo.passportName"
          @click="copyFn(row.id)" style="line-height:24px; font-size:12px;">采用</Button>
      </template>
    </Table>
    <div class="mackCon pf pr" v-if="isCopy">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">采用到我的安全规则库 <i class="closeIncon f30 pa" @click="isCopy = false">×</i></div>
        <div class="bodyCon tal">
          <h4 class="f14" style="margin-bottom:10px;">请选择应用到的分组</h4>
          <Checkbox-group v-model="selectVal" style="width:420px;">
            <Checkbox :label="item.id" v-for="(item, index) in this.$store.state.securityCenter.allSecurityGroup"
              :key="index" style="width:200px;" class="ells1"><span style="padding-left:10px;">{{ item.securityName
              }}</span>
            </Checkbox>
          </Checkbox-group>
        </div>
        <div class="footCon tar">
          <Button style="margin-left:10px;" @click="isCopy = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" @click="rulesStatus(0)">仅采用不启用</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary" @click="rulesStatus(1)">采用并启用</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRuleShare } from '@/requests/securityCenter'
export default {
  props: ['tableList', 'loading'],
  data () {
    return {
      isCopy: false,
      btnLoading: false,
      selectVal: [],
      columns: [
        {
          title: 'ID',
          width: 60,
          key: 'ruleId',
          align: 'center'
        },
        {
          title: '规则名称',
          key: 'ruleName',
          align: 'center',
          width: 200,
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.tableList[params.index].ruleName,
              h('div', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.tableList[params.index].ruleName)
            ])
          }
        },
        {
          title: '规则介绍',
          key: 'ruleIntroduction',
          ellipsis: true,
          align: 'center',
          width: 240,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.tableList[params.index].ruleIntroduction,
              h('div', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.tableList[params.index].ruleIntroduction)
            ])
          }
        },
        {
          title: '版本号',
          key: 'ruleVersion',
          align: 'center'
        },
        {
          title: '采用次数',
          key: 'shareCount',
          align: 'center',
          sortable: true,
          slot:'shareCount',
        },
        
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
        },
        {
          title: '最近更新时间',
          key: 'modifyTime',
          align: 'center',
        },
        {
          title: '作者',
          key: 'createBy',
          align: 'center',
          slot:'createBy',
          sortable: true
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          slot: 'action',
          width: 120,
        }
      ],
      curId: '',
      enable: 0,
      tableWidth: '1400'
    }
  },
  watch: {
    tableList () {
    },
    isCopy () {
      if (this.isCopy) {
        this.$store.dispatch('securityCenter/actionSetSecurityInfo')
      }
    }
  },
  mounted () {
    // this.$store.dispatch('securityCenter/actionSetSecurityInfo')
  },
  methods: {
    copyFn (id) {
      this.isCopy = true
      this.curId = id
    },
    async rulesStatus (item) {
      // if (this.selectVal == '') {
      //   this.$Message.error('暂未选择分组，请选择应用到的分组！')
      //   return
      // }
      let res = await getRuleShare({
        shareId: this.curId,
        groupIds: this.selectVal.toString(),
        enable: item
      })
      this.$emit('refresh')
      if (res.code == 200) {
        this.$Notice.success({
          title: '复制成功，请前往我的规则库查看',
        })
        this.isCopy = false
      } else {
        this.$Notice.warning({
          title: '复制失败',
          desc: res.msg,
        })
      }
    },
  },
}
</script>
<style lang="scss" >
.shareTable {

  .ivu-table-wrapper,
  .ivu-table {
    overflow: inherit;
  }

  .ivu-tooltip .ivu-tooltip-rel {
    width: auto !important;
    max-width: 300px !important;
  }

  .ivu-table-cell {
    padding: 0 4px !important;
  }

  .ivu-tooltip {
    width: auto;
    max-width: 300px !important;
  }

  .bodyCon {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>